import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { detectBrowser } from '@helper';
import { PriceLimits, Site } from '@model';
import { GlobalAlertService, SiteService, TimezonesService } from '@service';

@Component({
  selector: 'bmd-site-home',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./site-home.component.scss'],
  templateUrl: './site-home.html',
})
export class SiteHomeComponent implements OnChanges {
  @Input() site: Site;
  @Input() siteForm: FormGroup;
  @Input() priceLimits: PriceLimits;
  lastRefreshed: string;
  isFirefox: boolean;

  constructor(
    private timezoneService: TimezonesService,
    private translateService: TranslateService,
    private siteService: SiteService,
    private alertService: GlobalAlertService,
  ) {
    this.isFirefox = detectBrowser().includes('Firefox');
  }

  public get operationCostPerMWh() {
    return this.siteForm.get('operationCostPerMWh') as FormControl;
  }

  public get maxRegupMw() {
    return this.siteForm.get('maxRegupMw') as FormControl;
  }

  public get maxRegdownMw() {
    return this.siteForm.get('maxRegdownMw') as FormControl;
  }

  public get maxRrsMw() {
    return this.siteForm.get('maxRrsMw') as FormControl;
  }

  public get maxEcrsMw() {
    return this.siteForm.get('maxEcrsMw') as FormControl;
  }

  public get maxNsrsMw() {
    return this.siteForm.get('maxNsrsMw') as FormControl;
  }

  public get ercotMinPrice() {
    return this.siteForm.get('ercotMinPrice') as FormControl;
  }

  public get ercotMaxPrice() {
    return this.siteForm.get('ercotMaxPrice') as FormControl;
  }

  ngOnChanges(): void {
    this.getLastSave();
  }

  getLastSave(): void {
    this.lastRefreshed = this.timezoneService.getDateTimeDisplayLabel(this.site?.parentId, this.site?.lastUpdatedDate);
    if (this.lastRefreshed === '') {
      this.lastRefreshed = this.translateService.instant('last.refreshed.never');
    }
  }

  saveSite() {
    this.site.config.operationCostPerMWh = this.operationCostPerMWh.value;
    this.site.config.maxRegupMw = this.maxRegupMw.value;
    this.site.config.maxRegdownMw = this.maxRegdownMw.value;
    this.site.config.maxRrsMw = this.maxRrsMw.value;
    this.site.config.maxEcrsMw = this.maxEcrsMw.value;
    this.site.config.maxNsrsMw = this.maxNsrsMw.value;
    this.site.config.ercotMaxPrice = this.ercotMaxPrice.value;
    this.site.config.ercotMinPrice = this.ercotMinPrice.value;

    this.siteService.postSiteConfig$(this.site.id, this.site.config).subscribe(resp => {
      this.alertService.setSuccess('Site configuration has been saved successfully!');
    });
  }

  updateRtForecastSource() {}
}
